import React, { useState, useEffect } from 'react';
import './home.css';
import {Link} from 'react-router-dom';
import Navbar from '../../components/navbar/';
import { useSelector, useDispatch} from 'react-redux';
import firebase from '../../config/firebase';
import DocumentsList from '../../components/document-list/';
import logoDelta from './images/logo.png';
import { Redirect } from 'react-router-dom';
import {DebounceInput} from 'react-debounce-input';
import "animate.css"

function Home({match}){
    

    const [documentos, setDocumentos] = useState([]);    
    const [pesquisa, setPesquisa] = useState('0');
    let listaDocs = []; 
    const usuarioEmail = useSelector(state => state.usuarioEmail);

    


    useEffect(() => {
        if (usuarioEmail === "sistemadeltario@gmail.com") {
            firebase.firestore().collection('db-app').where('cpf','==',pesquisa).get().then(async (resultado) => {
                await resultado.docs.forEach(doc => {  
                        if(doc.data().cpf.indexOf(pesquisa) >= 0)
                        {      
                            listaDocs.push({
                                id: doc.id,
                                ...doc.data()
                            })             
                        } else {

                        }
               })
       
               setDocumentos(listaDocs);
           });
        } else {            
            firebase.firestore().collection('db-app').where('data','==',pesquisa).where('email','==',usuarioEmail.toLowerCase()).get().then(async (resultado) => {
                await resultado.docs.forEach(doc => {                   
                    if(doc.data().data.indexOf(pesquisa) >= 0)
                        {      
                            listaDocs.push({
                                id: doc.id,
                                ...doc.data()
                            })             
                        } else {

                        }
               })
       
               setDocumentos(listaDocs);
           });
        }
    },[pesquisa]);

    return(
        <>
    {useSelector(state => state.usuarioLogado) === 0 ? <Redirect to='/' /> : null}  

                {           
                    useSelector(state => state.usuarioEmail) === "sistemadeltario@gmail.com" ? 
                    <>
                        <div>
                        <img className="animate__animated animate__flash logo-delta" src={logoDelta}/>
                        <DebounceInput
                            minLength={7}
                            className="search-input form-control text-center"
                            // debounceTimeout={300}
                            placeholder = "Pesquisar documento pelo CPF/CNPJ" 
                            onChange={(e) => setPesquisa(e.target.value)}
                        />
                        
                        <h2 className="title-home">Visão geral de Documentos</h2>
                        <div className="cards-home p-3">
                            {documentos.map(item => <DocumentsList pdf={item.pdf} cpf={item.cpf} email={item.email} tipo={item.tipo} nome={item.nome} competencia={item.data} id={item.id} year={item.year}/>) }
                        </div>
                        </div>
                        <Navbar />

                </>
                :
                <>   
                        <div>
                            <img className="animate__animated animate__flash logo-delta" src={logoDelta}/>                            
                            <select onChange={(e) => setPesquisa(e.target.value)} className="form-select select-date">
                                <option disabled selected>Selecione o mês para consultar</option>
                                <option value="Janeiro">Janeiro</option>
                                <option value="Fevereiro">Fevereiro</option>
                                <option value="Março">Março</option>
                                <option value="Abril">Abril</option>
                                <option value="Maio">Maio</option>
                                <option value="Junho">Junho</option>
                                <option value="Julho">Julho</option>
                                <option value="Agosto">Agosto</option>
                                <option value="Setembro">Setembro</option>
                                <option value="Outubro">Outubro</option>
                                <option value="Novembro">Novembro</option>
                                <option value="Dezembro">Dezembro</option>
                            </select>
                            <h2 className="title-home">Meus Documentos</h2>
                            <div className="cards-home p-3">
                                {documentos.map(item => <DocumentsList pdf={item.pdf} cpf={item.cpf} email={item.email} nome={item.nome} competencia={item.data} id={item.id} tipo={item.tipo} year={item.year}/>) }
                            </div>
                        </div>
                        <Navbar />
                </>
                }              


        </>
    )
}

export default Home